import React from 'react';

import Cart from '@material-ui/icons/AddShoppingCart';
import Remove from '@material-ui/icons/RemoveCircle';
import Save from '@material-ui/icons/Save';
import Preview from './Preview';

import Button from '@material-ui/core/Button';

import { hashHistory } from 'browserHistory';
import { Divider } from '@material-ui/core';

const CheckoutOptions = (props) => {

    function getButtonCol(width, button, description) {
        return <div style={{ width: width }}>
            <div>
                {button}
            </div>
            <div style={{ marginTop: 20, fontSize: 14, color: 'darkgrey' }}>
                {description}
            </div>
        </div>
    }

    const { actions, portfolio, shoppingCartActions, onReset = () => { } } = props;

    if (portfolio.id) {
        return <div>
            <div style={{ fontSize: 26 }}>Review</div>
            <Preview {...props} />
            <Divider style={{ marginTop: 20, marginBottom: 20 }} />
            <div style={{ display: 'flex', marginTop: 20, textAlign: 'center' }}>
                {getButtonCol('50%', <Button color={'primary'} variant={'outlined'} onClick={() => {
                    shoppingCartActions.addPortfolioToCart(portfolio);
                    hashHistory.push('/ShoppingCart');
                }}><Save style={{ marginRight: 10 }} />Update</Button>, 'Update the portfolio with your changes.')}
                {getButtonCol('50%', <Button color={'primary'} variant={'outlined'} onClick={() => {
                    hashHistory.push('/ShoppingCart');
                }}><Remove style={{ marginRight: 10 }} />Discard Changes</Button>, 'Ignore the changes you made.')}
            </div>
        </div>

    }
    else {



        return <div>
            <div style={{ fontSize: 26 }}>Review</div>
            <Preview {...props} />
            <Divider style={{ marginTop: 20, marginBottom: 20 }} />
            <div style={{ display: 'flex', marginTop: 20, textAlign: 'center' }}>
                {/* {getButtonCol('33%', <Button color={'primary'} variant={'outlined'} onClick={() => {
                    shoppingCartActions.addPortfolioToCart(portfolio);
                    hashHistory.push('/ShoppingCart');
                }}><Money style={{ marginRight: 10 }} />Checkout Now</Button>, 'Submit your portfolios for analysis.')} */}

                {getButtonCol('50%', <Button color={'primary'} variant={'outlined'} onClick={() => {
                    shoppingCartActions.addPortfolioToCart(portfolio);
                    hashHistory.push('/ShoppingCart');
                }}><Cart style={{ marginRight: 10 }} />Add to Cart</Button>, 'Add this portfolio to your cart')}

                {getButtonCol('50%', <Button color={'primary'} variant={'outlined'} onClick={() => {
                    actions.resetPortfolio();
                    onReset();
                }}><Remove style={{ marginRight: 10 }} />Discard Changes</Button>, 'Clear all entered data')}
            </div>
        </div>
    }
};

const Render = CheckoutOptions;

function isComplete(props) {
    return true;
}

export { isComplete, Render };


// WEBPACK FOOTER //
// ./src/portfolioEntryWizard/components/CheckoutOptions.js